module.exports = __webpack_public_path__ + "static/media/adherence.175c5729.svg";